import Link from 'next/link'
import { Wrapper } from '@/components/CheckoutTerms.styles'

const CheckoutTerms: React.FC<{ termsOwner: string; termsUrl: string; privacyPolicyUrl: string }> = ({
  termsOwner,
  termsUrl,
  privacyPolicyUrl,
}) => {
  return (
    <>
      <Wrapper>
        By continuing you agree to {termsOwner}{' '}
        <Link href={termsUrl} target="_blank">
          Terms & Conditions
        </Link>{' '}
        and{' '}
        <Link href={privacyPolicyUrl} target="_blank">
          Privacy Policy
        </Link>
      </Wrapper>
    </>
  )
}

export default CheckoutTerms
